import { DetailCard } from "@hatch-digital-nl/abs-storybook/legacy";
import { ComponentProps } from "react";
import { Dispatch } from "redux";
import downloadImage from "../../../common/images/download.svg";
import { CertificateInterface } from "../../../common/interfaces/CertificateInterface";
import { handleOnDownloadClick } from "../../../common/utils/handleOnDownloadClick";
import { handleCertificateRenewal } from "./handleCertificateRenewal";
import { ModalButtonActionData } from "@hatch-digital-nl/abs-storybook/legacy";

type DetailCardAction = NonNullable<
    ComponentProps<typeof DetailCard>["actions"]
>[number];

interface Props {
    certificate: CertificateInterface;
    dispatch: Dispatch;
    isOpenFormLoading: boolean;
    actionData: ModalButtonActionData[];
    showRenewButton: boolean;
    renewButtonText?: string;
    renewButtonImage?: string;
}

export const getEmployeeCertificateCardActionData = (
    props: Props,
): DetailCardAction[] => {
    const {
        certificate,
        dispatch,
        isOpenFormLoading,
        actionData,
        showRenewButton,
        renewButtonText,
        renewButtonImage,
    } = props;

    const actions: DetailCardAction[] = [];

    if (certificate.certificate_file.file_url) {
        actions.push({
            type: "link",
            icon: downloadImage,
            label: "Download",
            onClick: () => {
                void handleOnDownloadClick(
                    certificate.certificate_file.file_url,
                );
            },
        });
    }

    if (actionData.length > 0) {
        actions.push({
            type: "menu",
            items: actionData,
        });
    }

    if (showRenewButton && renewButtonText) {
        actions.push({
            type: "button",
            label: renewButtonText,
            icon: renewButtonImage,
            isLoading: isOpenFormLoading,
            onClick: () =>
                handleCertificateRenewal({
                    item: certificate,
                    dispatch,
                }),
        });
    }

    return actions;
};
